module.exports = __webpack_public_path__ + "img/Twitter.541519c3.png";